import { createBrowserRouter, Navigate, useParams } from "react-router-dom";
import { App } from "./App";
import { AboutPage } from "@/pages/AboutPage";
import { BuildingPage } from "@/pages/BuildingPage";
import { ContactPage } from "@/pages/ContactPage";
import { GptsPage } from "@/pages/GptsPage";
import { HomePage } from "@/pages/HomePage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { NowPage } from "@/pages/NowPage";
import { PaperDetailPage } from "@/pages/PaperDetailPage";
import { PublicationDetailPage } from "@/pages/PublicationDetailPage";
import { PublicationsPage } from "@/pages/PublicationsPage";
import { TalksPage } from "@/pages/TalksPage";
import { TeachingPage } from "@/pages/TeachingPage";
import { ThinkingDetailPage } from "@/pages/ThinkingDetailPage";
import { ThinkingPage } from "@/pages/ThinkingPage";
import { WorkCasePage } from "@/pages/WorkCasePage";
import { WorkPage } from "@/pages/WorkPage";
import { WorkWithJayPage } from "@/pages/WorkWithJayPage";

function PublicationsSlugRedirect() {
  const { slug = "" } = useParams();
  return <Navigate to={`/resources/${slug}`} replace />;
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "about", element: <AboutPage /> },
      { path: "building", element: <BuildingPage /> },
      { path: "work", element: <WorkPage /> },
      { path: "work/gpts", element: <GptsPage /> },
      { path: "work/:slug", element: <WorkCasePage /> },
      { path: "work-with-jay", element: <WorkWithJayPage /> },
      { path: "thinking", element: <ThinkingPage /> },
      { path: "thinking/:slug", element: <ThinkingDetailPage /> },
      { path: "now", element: <NowPage /> },
      { path: "research", element: <Navigate to="/resources#research" replace /> },
      { path: "research/:slug", element: <PaperDetailPage /> },
      { path: "publications", element: <Navigate to="/resources" replace /> },
      { path: "publications/:slug", element: <PublicationsSlugRedirect /> },
      { path: "resources", element: <PublicationsPage /> },
      { path: "resources/:slug", element: <PublicationDetailPage /> },
      { path: "talks", element: <TalksPage /> },
      { path: "teaching", element: <TeachingPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
